import React from 'react'
import { FormattedMessage } from 'react-intl'
export const MessageTab = (props) => {
    const tabsdata = [
        {name:<FormattedMessage id="RECRUITER.MESSAGES.TAB.COMPANY" defaultMessage="Company" />,
         svgicon:  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z" />
</svg>
},
      
        {name:<FormattedMessage id="RECRUITER.MESSAGES.TAB.INDIVIDUAL" defaultMessage="Individual" />, 
        svgicon:   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
</svg>
}
    ]
    const HandleTabChange = (data)=> {
        props?.TabHandle(data)
      }
  return (
<div className='bg-[#FAF9F8] flex justify-center mt-5 mx-auto lg:max-w-6xl '>
            {tabsdata.map((data, index) => (
            <div key={index} onClick={()=> HandleTabChange(data.name.props.defaultMessage)} className={`${data.name.props.defaultMessage === props.tab ? 'text-[#0078ae] font-bold border-[#0078ae] ':'border-neutral-200' } cursor-pointer flex items-center py-4 justify-center w-1/2 space-x-2 border`}>
           {data.svgicon}
                <span>{data.name}</span>
        </div>
        
        ))}
             
              
        </div>
  )
}
